

export class FilterDate {
  constructor(  
  public startDate: string,
  public endDate: string
  ){  }
}